import { render, staticRenderFns } from "./ClassesView.vue?vue&type=template&id=83fc0afa&scoped=true"
import script from "./ClassesView.vue?vue&type=script&lang=js"
export * from "./ClassesView.vue?vue&type=script&lang=js"
import style0 from "./ClassesView.vue?vue&type=style&index=0&id=83fc0afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fc0afa",
  null
  
)

export default component.exports